"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importStar(require("@travelnest/merlin.theme"));
exports.StyleWrapper = styled_1.default.div `
background: ${merlin_theme_1.palette.greyscale.lightest};
overflow-x: scroll;
overflow-y: hidden;
width: 100%;
height: ${(props) => props.height};
box-sizing: border-box;
padding: ${merlin_theme_1.default.layout.spacing.smallest};
max-width: 750px;
font-family: ${merlin_theme_1.default.typography.fonts.base};

.pricing-eq-bar-graph__flex-box-horizontal {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 100%;
    width: 100%;
}

.pricing-eq-bar-graph__legend {
    height: 100%;
	flex-basis: 7%;
	min-width: 30px;
	font-size: 0.8rem;
	position: relative;
	background: ${merlin_theme_1.palette.greyscale.lightest};
}

.pricing-eq-bar-graph__max-price {
    position: absolute;
    top: 0%;
}

.pricing-eq-bar-graph__std-price {
    position: absolute;
    top: 42%;
}

.pricing-eq-bar-graph__min-price {
    position: absolute;
    top: 88%;
}

.pricing-eq-bar-graph__avg-price {
    position: absolute;
    top: 100%;
}

.pricing-eq-bar-graph__bars {
    height: 100%;
    flex-basis: 93%;
	display: flex;
}

.pricing-eq-bar-graph__bar {
    height: 100%;
	width: 100%;
    flex-basis: auto;
    /* One bar for each month */
	max-width: calc(100%/12);
	min-width: 20px;
}

.pricing-eq-bar-graph__price {
    text-align: center;
    width: 100%;
    flex-basis: auto;
    /* One price for each month */
    font-size: 0.8em;
    color: ${merlin_theme_1.default.colours.primary.default};
    margin: 0;
}

.pricing-eq-bar-graph__rule {
    border: none;
    border-bottom: 1px solid #eaeaea;
    margin: 30px 0px;
}

`;
//# sourceMappingURL=PricingEQBar.styled.js.map